import { CoefficientOption } from '../models/coefficient';

export const COEFFICIENTS: Array<CoefficientOption> = [
  {
    id: 1,
    fuel: 'węgiel',
    efficiency: 0.75,
    price_value: 0.095,
    co2_value: 94.6,
    car_co2: 0.12,
    tree_co2: 5
  },
  {
    id: 2,
    fuel: 'gaz ziemny',
    efficiency: 0.95,
    price_value: 0.28,
    co2_value: 56.1,
    car_co2: 0.12,
    tree_co2: 5
  },
  {
    id: 3,
    fuel: 'energia elektryczna',
    efficiency: 1,
    price_value: 0.65,
    co2_value: 183.3,
    car_co2: 0.12,
    tree_co2: 5
  },
  {
    id: 4,
    fuel: 'olej opałowy',
    efficiency: 0.85,
    price_value: 0.51,
    co2_value: 76.6,
    car_co2: 0.12,
    tree_co2: 5
  }
];

export const ENERGY_SAVING_FACTOR = 17.9923;

/*
Budynek jednorodzinny, EK = 95 kWh/m2/rok, ogrzewanie stanowi 70% zapotrzebowania budynku,
współczynnik nakładu 1, sprawność systemu ogrzewania 100%:
*/
export const USAGE = 10000; // kWh/rok
